import InfoPages from "../index";
import PageTitle from "../../../ui/PageTitle";
import MESSAGES from "../../../constants/messages";

const RefundPolicy = () => {
  return (
    <InfoPages>
      <PageTitle title={MESSAGES.REFUND_POLICY}/>

      <p><strong>Effective Date:</strong> May 14, 2026</p>

      <p>
        Welcome to <strong>ucr-registration.org</strong>, operated by
        <strong>United Carrier Route Compliance</strong> (“Company,” “we,” “our,” or “us”).
      </p>

      <p>
        This Refund Policy explains the terms under which refunds may be requested for services
        purchased through our website.
      </p>

      <h2>1. Service Nature</h2>
      <p>
        United Carrier Route Compliance provides third-party filing and compliance assistance services
        related to transportation registrations, permits, and compliance support.
      </p>

      <p>
        By purchasing services through our website, customers acknowledge that work may begin shortly
        after an order is submitted.
      </p>

      <h2>2. Refund Eligibility</h2>
      <p>Customers may request a refund within 24 hours of purchase if:</p>
      <ul style={{marginLeft: "40px"}}>
        <li>Filing work has not yet been submitted to a government agency;</li>
        <li>Services have not been substantially completed;</li>
        <li>No material work has been performed on the order.</li>
      </ul>

      <p>
        Refund requests must be submitted via email to
        <a href="mailto:support@ucr-registration.org">support@ucr-registration.org</a>
        with sufficient order details for review.
      </p>

      <h2>3. Partial Refunds</h2>
      <p>
        In some situations, partial refunds may be issued if work has already started but has not been
        fully completed.
      </p>

      <p>Examples may include:</p>
      <ul style={{marginLeft: "40px"}}>
        <li>Document review already completed;</li>
        <li>Filing preparation already started;</li>
        <li>Customer cancels after partial administrative work has been performed.</li>
      </ul>

      <p>Refund eligibility will be reviewed on a case-by-case basis.</p>

      <h2>4. Non-Refundable Items</h2>
      <p>The following are generally non-refundable:</p>
      <ul style={{marginLeft: "40px"}}>
        <li>Government filing fees already paid or submitted;</li>
        <li>Fees paid to third-party agencies or service providers;</li>
        <li>Services already completed or substantially completed;</li>
        <li>Orders submitted using incorrect customer information after work has begun.</li>
      </ul>

      <p>If a filing has already been submitted to a government agency, refunds may be unavailable.</p>

      <h2>5. Incorrect Information Submitted by Customer</h2>
      <p>
        Customers are responsible for ensuring that all submitted information is accurate.
      </p>

      <p>
        United Carrier Route Compliance is not responsible for delays, rejections, penalties, or
        additional fees resulting from inaccurate, incomplete, or unauthorized customer information.
      </p>

      <h2>6. Processing Time for Approved Refunds</h2>
      <p>
        If a refund is approved, it will generally be processed within 5–10 business days, depending on
        the customer’s financial institution and payment provider.
      </p>

      <h2>7. Fraud Prevention & Chargebacks</h2>
      <p>
        Customers agree to contact United Carrier Route Compliance first regarding billing concerns before
        initiating a chargeback or payment dispute.
      </p>

      <p>
        Unauthorized or fraudulent chargebacks may be disputed with supporting documentation, including
        customer authorization, website acceptance of Terms & Conditions, and submitted order information.
      </p>

      <h2>8. Policy Updates</h2>
      <p>
        United Carrier Route Compliance reserves the right to revise or update this Refund Policy at any
        time without prior notice.
      </p>

      <p>Continued use of our services constitutes acceptance of any updates.</p>

      <h2>9. Contact Information</h2>
      <p>
        <strong>United Carrier Route Compliance</strong><br/>
        6817 Foothill Blvd<br/>
        Tujunga, CA 91042<br/>
        Website: <a href="https://ucr-registration.org">https://ucr-registration.org</a><br/>
        Email: <a href="mailto:support@ucr-registration.org">support@ucr-registration.org</a>
      </p>

    </InfoPages>
  );
};

export default RefundPolicy;
